package com.devi3east.bashbuddy.favorites.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.features.events.common.EventRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class FavoriteEventsViewModel(
    private val repository: EventRepository,
    private val tokenProvider: () -> String?
) : ViewModel() {

    private val _uiState = MutableStateFlow(FavoriteEventsUiState())
    val uiState: StateFlow<FavoriteEventsUiState> = _uiState

    fun loadFavoriteEvents() {
        val token = tokenProvider() ?: run {
            return
        }
        _uiState.value = _uiState.value.copy(isLoading = true)
        viewModelScope.launch {
            try {
                val favorites = repository.getFavoriteEvents(token)
                _uiState.value = _uiState.value.copy(
                    isLoading = false,
                    errorMessage = null,
                    eventsList = favorites
                )
            } catch (e: Exception) {
                _uiState.value = FavoriteEventsUiState(errorMessage = "Failed to load favorites")
            }
        }
    }

    fun removeFavorite(eventId: String) {
        val token = tokenProvider() ?: return
        viewModelScope.launch {
            val success = repository.removeFavorite(token, eventId)
            if (success) loadFavoriteEvents()
        }
    }

}